import React from 'react';
import { Paragraph } from 'operation-diameter';

export default {
  title: "Connect to your client's Business Bank Account",
  leadParagraph:
    "Provide us with the last 6 months of your client's business transactions",
  ob: {
    heading: 'Instant one-time connection',
    clientEmailLabel: "Client's email address",
    clientEmail:
      "Please enter your client's email to send them a link to complete Open Banking.",
    clientEmailButton: 'Send Open Banking link',
    clientEmailHeading: 'Thank you for using Open Banking',
    clientEmailRetryButton: 'Retry sending the link',
    mainParagraph: () => (
      <Paragraph>
        We’ve partnered with TrueLayer, an FCA regulated service to make it
        easier than ever to provide your client’s bank statements. Send this
        link to your client to enable them to sign in to their{' '}
        <strong>main business account only</strong> and it will give us secure,
        one-time access to view their transactions.
      </Paragraph>
    ),
    footerParagraph:
      'We receive the historical transactions we need to give your client an accurate price. We don’t continue to monitor your client’s account activity.',
    notice:
      'Funding Circle has partnered with TrueLayer (an FCA regulated service) to provide connections to the following banks:',
    button: 'Return to portal',
    returnToPortal: 'Return to Portal',
    supportedBanksTitle: 'Funding Circle can connect to the following banks:',
    submitted:
      'After your client has signed into Open Banking, refresh this page to continue to the next step.'
  }
};
